export function parseBluNoteFinalize(content) {
  const text = String(content || "");
  const match = text.match(/```blu-note-finalize\s*([\s\S]*?)```/i);
  if (!match) return null;
  try {
    const parsed = JSON.parse(match[1].trim());
    if (!parsed?.client_id || !parsed?.client_name || !parsed?.content) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function normalizeBluNoteFinalizePayload(raw) {
  if (!raw || typeof raw !== "object") return null;
  const title = String(raw.title || "").trim();
  const content = String(raw.content || "").trim();
  if (!content) return null;
  return {
    client_id: String(raw.client_id || "").trim(),
    client_name: String(raw.client_name || "").trim(),
    title: title || `${String(raw.client_name || "").trim()} x TAĪSTU`,
    content,
    status: "draft",
  };
}

export function stripBluNoteFinalizeBlock(content) {
  return String(content || "").replace(/```blu-note-finalize[\s\S]*?```/gi, "").trim();
}
